<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout wrap>
      <v-flex md12>
        <div>
          <material-card color="primary" title="Unmatched Meters">
            <v-spacer />
            <v-text-field
              v-model="searchDevice"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            />
            <v-dialog v-model="dialogDeviceEdit" max-width="400px">
              <v-card>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-text-field
                        v-model="editedDeviceItem.deviceid"
                        label="Meter Id"
                        disabled
                      />
                      <v-autocomplete
                        dense
                        v-model="editedDeviceItem.userSelect"
                        :items="unmatchedUsers"
                        label="Unmatched Users"
                      ></v-autocomplete>
                    </v-layout>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <v-btn color="blue darken-1" @click="closeDeviceEdit"
                    >Cancel</v-btn
                  >
                  <v-btn color="green darken-1" @click="editDevice">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-data-table
              :headers="headersDeviceList"
              :items="DeviceList"
              :search="searchDevice"
              class="dashboard-tables"
              hide-actions
            >
              <!-- change table header background and text color(or other properties) -->
              <template slot="headerCell" slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-general text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <!-- <td>{{ props.item.id }}</td> -->
                <td class="">{{ props.item.deviceid }}</td>
                <td class="">{{ props.item.device_name }}</td>
                <td class="">
                  {{
                    props.item.device_count !== null &&
                    props.item.device_count !== ""
                      ? props.item.device_count
                      : "-"
                  }}
                </td>
                <td class="">{{ formatDeviceType(props.item.device_type) }}</td>
                <!-- <td class="">
                  {{
                    props.item.tags !== null ? props.item.tags.toString() : "-"
                  }}
                </td> -->
                <td class="">{{ formatDate(props.item.registeredat) }}</td>
                <td class="justify-center ">
                  <v-icon
                    medium
                    class="mr-2"
                    @click="editDeviceItem(props.item)"
                    >mdi-account-plus</v-icon
                  >
                </td>
              </template>
            </v-data-table>
            <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
              {{ snackText }}
              <v-btn flat @click="snack = false">Close</v-btn>
            </v-snackbar>
          </material-card>
        </div>
      </v-flex>
      <v-flex md12>
        <div>
          <material-card color="primary" title="Unmatched Users">
            <v-spacer />
            <v-text-field
              v-model="searchUser"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            />

            <v-dialog v-model="dialogUserEdit" max-width="400px">
              <v-card>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-text-field
                        v-model="editedUserItem.email"
                        label="Email"
                        disabled
                      />
                      <v-autocomplete
                        dense
                        v-model="editedUserItem.deviceSelect"
                        :items="orphanDevices"
                        label="Unmatched Meters"
                      ></v-autocomplete>
                    </v-layout>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <v-btn color="blue darken-1" @click="closeUserEdit"
                    >Cancel</v-btn
                  >
                  <v-btn color="green darken-1" @click="editUser">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-data-table
              :headers="headersUserList"
              :items="UserList"
              :search="searchUser"
              class="dashboard-tables"
              hide-actions
            >
              <!-- change table header background and text color(or other properties) -->
              <template slot="headerCell" slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-general text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <td class="">
                  {{
                    props.item.firstname !== null && props.item.firstname !== ""
                      ? props.item.firstname
                      : "-"
                  }}
                </td>
                <td class="">
                  {{
                    props.item.lastname !== null && props.item.lastname !== ""
                      ? props.item.lastname
                      : "-"
                  }}
                </td>
                <td class="">
                  {{
                    props.item.email !== null && props.item.email !== ""
                      ? props.item.email
                      : "-"
                  }}
                </td>
                <td class="">
                  {{
                    props.item.address !== null && props.item.address !== ""
                      ? props.item.address
                      : "-"
                  }}
                </td>
                <td class="">
                  {{
                    props.item.supply_number !== null &&
                    props.item.supply_number !== ""
                      ? props.item.supply_number
                      : "-"
                  }}
                </td>
                <td class="justify-center ">
                  <v-icon medium class="mr-2" @click="editUserItem(props.item)"
                    >mdi-server-plus</v-icon
                  >
                </td>
              </template>
            </v-data-table>
            <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
              {{ snackText }}
              <v-btn flat @click="snack = false">Close</v-btn>
            </v-snackbar>
          </material-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from "moment";

export default {
  data: () => ({
    snack: false,
    snackColor: "",
    snackText: "",
    pagination: {},
    DeviceList: [],
    orphanDevices: [],
    UserList: [],
    unmatchedUsers: [],
    rowsAmount: [
      10,
      15,
      20,
      { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 },
    ],
    dialogDeviceEdit: false,
    dialogUserEdit: false,
    searchDevice: "",
    searchUser: "",
    headersDeviceList: [
      { text: "Id", value: "id", align: " d-none" },
      { text: "Meter Id", value: "deviceid" },
      { text: "Meter Name", value: "device_name" },
      { text: "Meter Count", value: "device_count" },
      { text: "Meter Type", value: "device_type" },
      // { text: "Projects", value: "tags" },
      { text: "Registered At", value: "registeredat" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    headersUserList: [
      { text: "Id", value: "id", align: " d-none" },
      { text: "First Name", value: "firstname" },
      { text: "Last Name", value: "lastname" },
      { text: "Email", value: "email", sortable: false },
      // { text: "Password", value: "password" },
      { text: "Address", value: "address" },
      { text: "Supply Number", value: "supply_number" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    editedDeviceIndex: -1,
    editedDeviceItem: {
      deviceid: "",
      userSelect: [],
    },
    editedUserIndex: -1,
    editedUserItem: {
      email: "",
      deviceSelect: [],
    },
    defaultItem: {},
  }),

  watch: {
    dialogDeviceEdit(val) {
      val || this.closeDeviceEdit();
    },
    dialogUserEdit(val) {
      val || this.closeUserEdit();
    },
  },

  // called when page is created before dom
  created() {
    this.getOrphanDevices();
    this.getUnmatchedUsers();
  },

  methods: {
    getOrphanDevices() {
      this.$http
        .get("devices/orphans")
        .then((response) => {
          this.DeviceList = response.data;
          this.orphanDevices = [];
          for (var i = 0; i < response.data.length; i++) {
            this.orphanDevices.push(response.data[i].deviceid);
          }
          localStorage.setItem("token", response.headers.token);
        })
        .catch((error) => console.log(error));
    },

    getUnmatchedUsers() {
      this.$http
        .get("admin/users/childless")
        .then((response) => {
          this.UserList = response.data;
          this.unmatchedUsers = [];
          for (var i = 0; i < response.data.length; i++) {
            this.unmatchedUsers.push(response.data[i].email);
          }
        })
        .catch((error) => console.log(error));
    },

    formatDate(datetime) {
      return moment(datetime).format("MMM DD, YYYY HH:mm:ss");
    },

    formatDeviceType(type) {
      let deviceTypeString = "Single Phase";
      if (type == 1) {
        return "Single Phase";
      } else if (type == 2) {
        return "Three Phase";
      }
    },

    // EDIT DEVICE

    editDeviceItem(item) {
      this.editedDeviceIndex = this.DeviceList.indexOf(item);
      this.editedDeviceItem = Object.assign({}, item);
      this.dialogDeviceEdit = true;
    },

    closeDeviceEdit() {
      this.dialogDeviceEdit = false;
      this.$nextTick(() => {
        this.editedDeviceItem = Object.assign({}, this.defaultItem);
        this.editedDeviceItem = -1;
      });
    },

    editDevice() {
      if (
        this.editedDeviceItem.userSelect == "" ||
        this.editedDeviceItem.userSelect == undefined
      ) {
        this.requiredUserInline();
      } else {
        let objectForEditDevice = {};
        objectForEditDevice.user_email = this.editedDeviceItem.userSelect;

        let endpoint = `devices/${this.editedDeviceItem.deviceid}`;
        let method = "patch";
        let tableItem = objectForEditDevice;
        this.$store
          .dispatch("editDevice", { endpoint, tableItem, method })
          .then((response) => {
            this.saveInline();
            this.getOrphanDevices();
            this.getUnmatchedUsers();
          })
          .catch((error) => {
            console.log(error);
            this.apiErrorInline();
          });

        this.closeDeviceEdit();
      }
    },

    // EDIT USER

    editUserItem(item) {
      this.editedUserIndex = this.DeviceList.indexOf(item);
      this.editedUserItem = Object.assign({}, item);
      this.dialogUserEdit = true;
    },

    closeUserEdit() {
      this.dialogUserEdit = false;
      this.$nextTick(() => {
        this.editedUserItem = Object.assign({}, this.defaultItem);
        this.editedUserItem = -1;
      });
    },

    editUser() {
      if (
        this.editedUserItem.deviceSelect == "" ||
        this.editedUserItem.deviceSelect == undefined
      ) {
        this.requiredDeviceInline();
      } else {
        let objectForEditDevice = {};
        objectForEditDevice.user_email = this.editedUserItem.email;

        let endpoint = `devices/${this.editedUserItem.deviceSelect}`;
        let method = "patch";
        let tableItem = objectForEditDevice;
        this.$store
          .dispatch("editDevice", { endpoint, tableItem, method })
          .then((response) => {
            this.saveInline();
            this.getUnmatchedUsers();
            this.getOrphanDevices();
          })
          .catch((error) => {
            console.log(error);
            this.apiErrorInline();
          });

        this.closeUserEdit();
      }
    },

    // toasts/snackbar messages for actions
    saveInline() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Success";
    },
    cancelInline() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Canceled";
    },
    apiErrorInline() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Something went wrong";
    },
    requiredUserInline() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Please select user";
    },
    requiredDeviceInline() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Please select device";
    },
    reset() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Data reset to default";
    },
    openInline() {
      this.snack = true;
      this.snackColor = "info";
      this.snackText = "Dialog opened";
    },
    closeInline() {
      console.log("Dialog closed");
    },
  },
};
</script>

<style>
table.v-table thead tr {
  color: red !important;
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
.dashboard-tables {
  max-height: 40vh;
  overflow-y: auto;
}
</style>
